import { Box, BoxProps, ColorOptions, Spacer, TextProps } from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/core'
import React, { useCallback, useState } from 'react'
import { SectionList } from 'react-native'
import { useStores } from '../../../data/store'
import { isIFrame } from '../../../utils'
import { pages, windowConfig } from '../../../utils/constants'
import { MobileProcessing } from '../../PaymentProcesseing/MobileProcessing'
import { ActionButton } from '../comps/ActionButton'
import { ExtraInfoInput } from '../comps/ExtraInfoInputModal'
import { InfoHeader } from '../comps/InfoHeader'
import { ListHeader } from '../comps/ListHeader'
import { ListDataProps, ListItem, ListItemProps } from '../comps/ListItem'
import { getPaymentObject } from '../comps/PaymentProcessingHelper'
import { ProgressIndicator } from '../comps/ProgressIndicator'

export const EligibleBankList = () => {
  const [checkedItem, setCheckedItem] = React.useState<ListItemProps>({} as any)
  const onRadioButtonClick = useCallback((checkedItem) => setCheckedItem(checkedItem), [])
  const navigation = useNavigation()
  const { REACT_APP_URL = '', REACT_APP_ENDPOINT = '' } = process.env

  const {
    banksWithEmiPlans,
    banksRequiresExtraInfoList,
    mobileNo,
    theme,
    subType,
    eligibilityResponseID,
    addCardPaymentMethod,
    uniqueWindowId,
  } = useStores((root) => ({
    banksRequiresExtraInfoList: root?.jioPayFinanceHub?.banksRequiresExtraInfoList,
    banksWithEmiPlans: root?.jioPayFinanceHub?.banksWithEmiPlans,
    mobileNo: root?.jioPayFinanceHub?.mobileNo,
    theme: root?.config?.merchantTheme,
    subType: root.jioPayFinanceHub?.subType,
    eligibilityResponseID: root.jioPayFinanceHub?.eligibilityResponseID,
    addCardPaymentMethod: root.transaction.addPaymentMethod,
    uniqueWindowId: root.config.uniqueWindowId,
  }))
  const TYPE = useRoute().params
  const [showExtraInfoInput, setShowExtraInfoInput] = React.useState(false)
  const [showPaymentProcessModal, setShowPaymentProcessModal] = useState(false)

  const loadProcessingScreen = useCallback(() => {
    const loaderUrl = REACT_APP_ENDPOINT
      ? `${REACT_APP_URL}/${REACT_APP_ENDPOINT}/loader.html`
      : `${REACT_APP_URL}/loader.html`
    if (!isIFrame()) {
      window.currentChild = window
    } else {
      try {
        window.currentChild = window.open(loaderUrl, `jiopayWindow-${uniqueWindowId}`, windowConfig)
        window.currentChild?.focus()
      } catch (e) {
        window.parent.postMessage(
          {
            txnId: 0,
            intentId: 897,
            status: 'error',
            message: 'Not supported direct payment in inframe checkout',
          },
          '*',
        )
      }
    }
    setShowPaymentProcessModal(true)
  }, [REACT_APP_ENDPOINT, REACT_APP_URL, uniqueWindowId])

  const handleCardPayment = useCallback(
    (selectedEMIData: any) => {
      const paymentMode = getPaymentObject({
        data: { mobile: mobileNo },
        payerMobile: mobileNo,
        subType,
        eligibilityResponseID,
        selectedEMIData,
      })
      addCardPaymentMethod(paymentMode)
      loadProcessingScreen()
    },
    [addCardPaymentMethod, eligibilityResponseID, loadProcessingScreen, mobileNo, subType],
  )

  const bankList: ListDataProps['section'][] = [
    {
      headerTitle: '',
      data: banksWithEmiPlans,
    },
    {
      headerTitle: '',
      data: banksRequiresExtraInfoList,
    },
  ]

  const renderItem = useCallback(
    (data: ListDataProps) => {
      return (
        <ListItem data={data} onRadioButtonClick={onRadioButtonClick} checkedObject={checkedItem} TYPE="BANK_LIST" />
      )
    },
    [checkedItem, onRadioButtonClick],
  )

  const renderSectionHeader = useCallback(({ section: { headerTitle } }) => {
    return <ListHeader headerTitle={headerTitle} />
  }, [])
  return (
    <Box {...styles.container} backgroundColor={theme?.bodyBgColor as ColorOptions}>
      <Box ph={24}>
        <ProgressIndicator data={['Eligibility', 'EMI Plan', 'Payment']} currentStep={2} />
      </Box>
      <Spacer size={18} />
      <InfoHeader mobileNo={mobileNo} theme={theme} onEditPress={() => navigation.goBack()} type={TYPE} />
      <SectionList
        sections={bankList}
        renderItem={renderItem}
        renderSectionHeader={renderSectionHeader}
        style={{ flex: 1 }}
        contentContainerStyle={{ flex: 1 }}
      />
      <Box ph={24}>
        <ActionButton
          disabled={Object.keys(checkedItem).length === 0}
          title={'Continue'}
          onPress={() => {
            if (checkedItem?.planSource === '2') {
              handleCardPayment(checkedItem?.emiPlans?.[0])
            } else if (checkedItem?.emiPlans) {
              navigation.navigate(pages.selectEmiPlans as never, checkedItem as never)
            } else {
              setShowExtraInfoInput(true)
            }
          }}
        />
      </Box>
      <ExtraInfoInput
        TYPE={TYPE}
        bankData={checkedItem}
        show={showExtraInfoInput}
        onDismiss={() => setShowExtraInfoInput(false)}
        makePayment={(emiPlan: any) => handleCardPayment(emiPlan)}
      />
      {showPaymentProcessModal && (
        <MobileProcessing setShow={setShowPaymentProcessModal} show={showPaymentProcessModal} />
      )}
    </Box>
  )
}

const styles = {
  container: {
    pv: 24,
    flexDirection: 'column',
    height: '100%',
    flex: 1,
  } as BoxProps,
  infoText: {
    fontSize: 14,
    fontFamily: 'jioType-medium',
    color: 'BRAND_COLOR_GRAY_1',
    lineHeight: 18,
  } as TextProps,
}
